"use client";

import {
  usePathname as useIntlPathname,
  useRouter as useIntlRouter,
} from "@/i18n/navigation";
import { setUserLocale } from "@/service/locale";
import { useLocale, useTranslations } from "next-intl";
import Image from "next/image";
import { useRouter as useNextRouter, usePathname } from "next/navigation";
import { useCallback } from "react";
import { briger } from "../../../public/images/logos";

const ChangeLanguage = () => {
  const locale = useLocale();
  const t = useTranslations("common");
  const rawPathname = usePathname(); // from next/navigation (includes /en prefix)
  const intlPathname = useIntlPathname(); // from next-intl (locale-stripped)
  const intlRouter = useIntlRouter();
  const nextRouter = useNextRouter();
  const isUserArea = rawPathname.startsWith("/user");

  const onChange = useCallback(async () => {
    const newLocale = locale === "de" ? "en" : "de";
    if (isUserArea) {
      await setUserLocale(newLocale);
      nextRouter.refresh();
    } else {
      // Public pages: navigate to the same path under the other locale
      intlRouter.replace(intlPathname, { locale: newLocale });
    }
  }, [locale, isUserArea, intlRouter, intlPathname, nextRouter]);

  return (
    <button className="cursor-pointer" onClick={onChange}>
      <Image
        src={briger}
        alt={
          locale === "de"
            ? t("imageAlt.unitedKingdomIcon")
            : t("imageAlt.germanyIcon")
        }
        width={50}
        height={40}
        className="h-10 w-[50px]"
      />
    </button>
  );
};

export default ChangeLanguage;
